import { makeAutoObservable } from 'mobx';
import apiService from 'Service';
import companyStore from './companyStore';

class CommonStore {
    invitations = []

    constructor() {
        makeAutoObservable(this)
    }

    setInvitations(invitations) {
        this.invitations = invitations || []
    }

    loadPendingInvitations() {
        return apiService.Account.getGuestPendient().then(data => {
            this.setInvitations(data || [])
            return data
        })
    }

    approveInvitation(token, keyCompany) {
        return apiService.Account.guestApprove(token, keyCompany).then(() => {
            this.invitations = this.invitations.filter(i => i.TokenRegister !== token)
            return apiService.Account.getMemberships()
        }).then(data => {
            if (data?.ThirdCompanies) {
                companyStore.setThirdPartyCompanies(data.ThirdCompanies)
            }
        })
    }

    rejectInvitation(token, keyCompany) {
        return apiService.Account.guestReject(token, keyCompany).then(() => {
            this.invitations = this.invitations.filter(i => i.TokenRegister !== token)
        })
    }

    clear() {
        this.invitations = []
    }
}

export default new CommonStore();
